const SHOW_EVENT = "error-overlay:show"
const HIDE_EVENT = "error-overlay:hide"

export function showErrorOverlay() {
  window.dispatchEvent(new Event(SHOW_EVENT))
}

export function hideErrorOverlay() {
  window.dispatchEvent(new Event(HIDE_EVENT))
}

export function onShowErrorOverlay(cb: () => void) {
  window.addEventListener(SHOW_EVENT, cb)
  return () => window.removeEventListener(SHOW_EVENT, cb)
}

export function onHideErrorOverlay(cb: () => void) {
  window.addEventListener(HIDE_EVENT, cb)
  return () => window.removeEventListener(HIDE_EVENT, cb)
}
